import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["id", "type", "duration", "remove", "clearable", "timerEnabled"];
import _setInterval from "@babel/runtime-corejs3/core-js-stable/set-interval";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useCallback, useEffect, useState } from 'react';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, border, mq } from '@rexlabs/styling';
import { NeutralBanner, InfoBanner, WarningBanner, ErrorBanner, SuccessBanner } from '../banner';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread({
    position: 'relative',
    overflow: 'hidden'
  }, border.styles({
    target: ['banner', 'toast.indicator'],
    bottom: {
      radius: 'l'
    }
  })), {}, {
    maxWidth: function maxWidth(_ref) {
      var token = _ref.token;
      return token('toast.maxWidth', '60.8rem');
    },
    boxShadow: function boxShadow(_ref2) {
      var token = _ref2.token;
      return token('toast.boxShadow', token('shadow.heavy'));
    }
  }, mq.styles({
    queries: {
      maxWidth: 's'
    },
    styles: {
      width: '100%',
      maxWidth: function maxWidth(_ref3) {
        var token = _ref3.token;
        return token('toast.mobile.maxWidth', '100%');
      }
    }
  })),
  indicator: {
    position: 'absolute',
    bottom: 0,
    height: '.3rem',
    width: '100%',
    transformOrigin: 'left'
  },
  remove: {
    display: 'none'
  },
  neutral: {
    backgroundColor: function backgroundColor(_ref4) {
      var token = _ref4.token;
      return token('color.border.primary.idle.contrast');
    }
  },
  info: {
    backgroundColor: function backgroundColor(_ref5) {
      var token = _ref5.token;
      return token('color.border.information.idle.default');
    }
  },
  warning: {
    backgroundColor: function backgroundColor(_ref6) {
      var token = _ref6.token;
      return token('color.border.warning.idle.default');
    }
  },
  error: {
    backgroundColor: function backgroundColor(_ref7) {
      var token = _ref7.token;
      return token('color.border.danger.idle.default');
    }
  },
  success: {
    backgroundColor: function backgroundColor(_ref8) {
      var token = _ref8.token;
      return token('color.border.success.idle.default');
    }
  }
});
export function Toast(_ref9) {
  var id = _ref9.id,
      _ref9$type = _ref9.type,
      type = _ref9$type === void 0 ? 'success' : _ref9$type,
      _ref9$duration = _ref9.duration,
      duration = _ref9$duration === void 0 ? 8000 : _ref9$duration,
      remove = _ref9.remove,
      _ref9$clearable = _ref9.clearable,
      clearable = _ref9$clearable === void 0 ? true : _ref9$clearable,
      _ref9$timerEnabled = _ref9.timerEnabled,
      timerEnabled = _ref9$timerEnabled === void 0 ? true : _ref9$timerEnabled,
      props = _objectWithoutProperties(_ref9, _excluded);

  var s = useStyles(defaultStyles);
  var timer = useRef(); // HACK: the progress stuff to be able to render a progress bar on the toast
  // is pretty hacky, definitely worth thinking about a more efficiient approach
  // that doesn't involve state changes every couple of milliseconds :/

  var _useState = useState(100),
      _useState2 = _slicedToArray(_useState, 2),
      progress = _useState2[0],
      setProgress = _useState2[1];

  var startInterval = useCallback(function () {
    if (timerEnabled && duration && !timer.current) {
      timer.current = _setInterval(function () {
        setProgress(function (pct) {
          return pct - 1;
        });
      }, duration / 100);
    }
  }, [timerEnabled, duration]);
  var pauseInterval = useCallback(function () {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = undefined;
    }
  }, []);
  var clearToast = useCallback(function () {
    pauseInterval();
    remove();
  }, [pauseInterval, remove]);
  useEffect(function () {
    if (timerEnabled) {
      startInterval();
    } else {
      pauseInterval();
    }
  }, // eslint-disable-next-line
  [timerEnabled]);
  useEffect(function () {
    if (progress <= 0) {
      clearToast();
    }
  }, [progress, clearToast]);
  var Banner = NeutralBanner;

  switch (type) {
    case 'info':
      Banner = InfoBanner;
      break;

    case 'warning':
      Banner = WarningBanner;
      break;

    case 'error':
      Banner = ErrorBanner;
      break;

    case 'success':
      Banner = SuccessBanner;
      break;
  }

  return /*#__PURE__*/React.createElement(Box, _extends({}, s('container'), {
    flexDirection: "column",
    onMouseOver: function onMouseOver() {
      pauseInterval();
    },
    onMouseLeave: function onMouseLeave() {
      startInterval();
    }
  }), /*#__PURE__*/React.createElement(Banner, _extends({}, props, {
    strong: true,
    key: id,
    handleClose: clearable ? clearToast : undefined
  })), /*#__PURE__*/React.createElement("div", _extends({}, s('indicator', type, {
    remove: !duration
  }), {
    style: {
      transform: "scaleX(".concat(progress / 100, ")")
    }
  })));
}
export default Toast;